import { ref, onMounted, onBeforeUnmount } from "vue";
import { throttle } from "./utils/throttle";

// 전역 resize 이벤트 리스너 관리
let globalResizeHandler = null;
let resizeListeners = new Set();

// 전역 resize 이벤트 초기화
const initGlobalResize = () => {
  if (typeof window === "undefined" || globalResizeHandler) return;

  globalResizeHandler = throttle(() => {
    resizeListeners.forEach((listener) => listener());
  }, 150);

  window.addEventListener("resize", globalResizeHandler);
};

// 전역 resize 이벤트 정리
const cleanupGlobalResize = () => {
  if (resizeListeners.size === 0 && globalResizeHandler) {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", globalResizeHandler);
    }
    globalResizeHandler = null;
  }
};

export const useDevice = () => {
  const isMobile = ref(false);

  const update = () => {
    if (typeof window !== "undefined") {
      isMobile.value = window.innerWidth <= 992;
    }
  };

  onMounted(() => {
    update();

    // 전역 resize 이벤트에 등록
    if (typeof window !== "undefined") {
      resizeListeners.add(update);
      initGlobalResize();
    }
  });

  onBeforeUnmount(() => {
    if (typeof window !== "undefined") {
      resizeListeners.delete(update);
      cleanupGlobalResize();
    }
  });

  return { isMobile };
};

//전역 resize 이벤트에 callback을 등록 함수
export const useResizeListener = (callback) => {
  onMounted(() => {
    if (typeof window !== "undefined") {
      resizeListeners.add(callback);
      initGlobalResize();
    }
  });

  onBeforeUnmount(() => {
    if (typeof window !== "undefined") {
      resizeListeners.delete(callback);
      cleanupGlobalResize();
    }
  });
};
